import common from "./common";
import IntroScene from "./scenes/IntroScene";
import QuestionScene from "./scenes/QuestionScene";
import BoardFlipScene from "./scenes/BoardFlipScene";
import SendDataScene from "./scenes/SendDataScene";
import EndScene from "./scenes/EndScene";
import GelButton from "./ui/GelButton";
import Button from "./ui/Button";


export default class Application
{
    constructor()
    {
        this.currentScene = null;

        this.basicButton = null;

        this.currentMusic = null;

        MEDIATOR.application = this;
    }

    init()
    {
        console.log('Application init');

        for(var i in common.config.questions)
        {
            if(common.config.questions[i].disabled)
            {
                for(var j in common.config.questions[i].fields)
                {
                    if(common.config.questions[i].fields[j].defaultIfDisabled !== null)
                    {
                        common.response[common.config.questions[i].fields[j].id] = common.config.questions[i].fields[j].defaultIfDisabled;
                    }
                }
            }
        }
        
        this.showIntro(true);

        common.muteButton = new GelButton('sound', common.baseUrl + 'assets/images/btn_sound_on.png', Button.POSITION_TOP_RIGHT);
        common.muteButton.signals.down.add(this.onMuteClick.bind(this));
        common.muteButton.muted = false;
        $('#game').append(common.muteButton.htmlElement);

        if(common.saveData.muted)
        {
            this.onMuteClick();
        }

        this.goGreenButton = $('<img id="p3-gogreen" src="' + common.baseUrl + 'assets/images/ui_logo_gogreen.png" />');
        $('#game').append(this.goGreenButton);
        //this.showEnd();
    }

    showIntro(flipBoards)
    {
        if(this.currentScene) this.currentScene.destroy();

        if(common.basicButton)
        {
            common.basicButton.htmlElement.show();
        }

        var scene = new IntroScene(flipBoards);
        scene.init();
        scene.signalListeners.push(
            scene.signals.next.add(this.showQuestion.bind(this), this),
            scene.signals.setMusic.add((music) => this.playMusic(music), this)
        );
        this.currentScene = scene;
    }

    showQuestion(backDirection = false)
    {
        if(this.currentScene.sceneId != 'question')
        {
            this.playMusic('music_question_loop_00');
        }

        if(this.currentScene) this.currentScene.destroy();

        if(common.basicButton)
        {
            common.basicButton.htmlElement.hide();
        }

        if(MEDIATOR.pcApp)
        {
            MEDIATOR.pcApp.startQuestions();
        }

        var scene = new QuestionScene(common.config.questions[common.currentQuestion], backDirection);
        scene.init();
        scene.signalListeners.push(
            scene.signals.next.add((type, id) => {
                this.showBoardFlip(type, id)
            }, this),
            scene.signals.previous.add((type, id) => 
            {
                if(common.currentQuestion <= 0)
                {
                    this.showIntro(false);
                }
                else
                {
                    common.currentQuestion--;
                    if(common.config.questions[common.currentQuestion].disabled)
                    {
                        common.currentQuestion--;
                    }
                    if(common.currentQuestion < 0)
                    {
                        this.showIntro(false);
                    }
                    else
                    {
                        this.showQuestion(true);
                    }
                }
            }, this)
        );
        this.currentScene = scene;
    }

    showBoardFlip(type, id)
    {
        if(this.currentScene) this.currentScene.destroy();
        
        console.log(common.response);

        common.currentQuestion++;

        if(common.currentQuestion < common.config.questions.length && common.config.questions[common.currentQuestion].disabled)
        {
            common.currentQuestion++;
        }

        var nextScene = common.currentQuestion < common.config.questions.length ? this.showQuestion.bind(this) : this.showSendData.bind(this);

        if(type != 'none' && !common.basicMode)
        {
            var scene = new BoardFlipScene(type, id);
            scene.init();
            scene.signalListeners.push(
                scene.signals.next.add(nextScene, this)
            );
            this.currentScene = scene;
        }
        else
        {
            nextScene();
        }
    }

    showSendData()
    {
        if(this.currentScene) this.currentScene.destroy();

        var scene = new SendDataScene();
        scene.signalListeners.push(
            scene.signals.next.add(this.showEnd.bind(this), this)
        );
        scene.init();
    }

    showEnd()
    {
        if(this.currentScene) this.currentScene.destroy();

        var scene = new EndScene();
        scene.init();
        this.currentScene = scene;

        this.playMusic('music_result_loop_00');
    }

    startScreenFlow()
    {
        /*
        setTimeout(() => {
            if(this.currentScene.sceneId == 'intro')
            {
                this.currentScene.addIntroPanel();
            }
        }, 9000); */
    }

    beginApp()
    {
        if(this.currentScene.sceneId == 'intro')
        {
            this.currentScene.addIntroPanel();
        }
    }

    playMusic(string)
    {
        if(this.currentMusic)
            this.currentMusic.stop();

        this.currentMusic = common.soundManager.play(string);
    }

    boardsFlipped()
    {
        console.log(this.currentScene.sceneId);
        if(this.currentScene.sceneId == 'boardflip' || this.currentScene.sceneId == 'intro')
        {
            this.currentScene.boardsFlipped();
        }
    }

    onMuteClick()
    {
        common.muteButton.muted = !common.muteButton.muted;
        if(common.muteButton.muted)
        {
            if(!common.videoPlaying)
            {
                common.soundManager.mute();
            }
            common.muteButton.setIcon(common.baseUrl + 'assets/images/btn_sound_off.png');
        }
        else
        {
            if(!common.videoPlaying)
            {
                common.soundManager.unmute();
            }
            common.muteButton.setIcon(common.baseUrl + 'assets/images/btn_sound_on.png');
        }
        common.saveData.muted = common.muteButton.muted;
    }

    onBallBounce()
    {
        common.soundManager.play(['sfx_ball_bounce_1', 'sfx_ball_bounce_2', 'sfx_ball_bounce_3', 'sfx_ball_bounce_4']);
    }

    onBallLand()
    {
        if(this.currentScene.sceneId == 'end')
        {
            this.currentScene.showEndPanel();
        }
    }

}